import script from "./detailHome.vue?vue&type=script&setup=true&lang=js"
export * from "./detailHome.vue?vue&type=script&setup=true&lang=js"

import "./detailHome.vue?vue&type=style&index=0&id=b82e9a3a&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\custom\\sdxlxh\\ShanDongXinLiZiXun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b82e9a3a"]])

export default __exports__